import { render, staticRenderFns } from "./PbcImagePost.vue?vue&type=template&id=f9949dce&scoped=true&"
import script from "./PbcImagePost.vue?vue&type=script&lang=js&"
export * from "./PbcImagePost.vue?vue&type=script&lang=js&"
import style0 from "./PbcImagePost.vue?vue&type=style&index=0&id=f9949dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9949dce",
  null
  
)

export default component.exports